export class BillDueDaysConfiguration {
    _termNumber = 0;
    jsTermNumber = 0;
    _daysDueAfterPeriodEnd = 0;
    jsDaysDueAfterPeriodEnd = 0;
    _type = "custom";
    _active = true;
    jsActive = true;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.daysDueAfterPeriodEnd = params.daysDueAfterPeriodEnd;
        if (params.type) {
            this.type = params.type;
        }
        if (params.active !== undefined)
            this.active = params.active;
        this.updateJsValues();
    }
    get active() {
        return this._active;
    }
    set active(v) {
        this._active = v;
        this.jsActive = v;
    }
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsDaysDueAfterPeriodEnd = this.daysDueAfterPeriodEnd;
        this.jsActive = this.active;
        // console.trace("js values updated for BillDueDaysConfiguration");
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.daysDueAfterPeriodEnd = this.jsDaysDueAfterPeriodEnd;
        this.active = this.jsActive;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(value) {
        // console.trace("term number set to: ", value);
        this._termNumber = value;
    }
    get daysDueAfterPeriodEnd() {
        return this._daysDueAfterPeriodEnd;
    }
    set daysDueAfterPeriodEnd(value) {
        //console.log("days due after period end set to: ", value);
        this._daysDueAfterPeriodEnd = value;
    }
    get json() {
        return {
            termNumber: this.termNumber,
            daysDueAfterPeriodEnd: this.daysDueAfterPeriodEnd,
            type: this.type,
            active: this.active,
        };
    }
    toJSON() {
        return this.json;
    }
}
